<script>
import FormGroup from '@/pages/components/form/horizontal/form-group.vue'
import formInput from "@wielink-application/shared/js/mixins/formInput";
import Price from "@/pages/components/form/input-only/price.vue";

export default {
  mixins: [formInput],
  components: {FormGroup, Price},
  props: {
    'groupClasses': {
      type: String,
      required: false
    },
    'label': {
      type: String,
      required: false
    },
    'step': {
      type: String,
      required: false,
      default: '0.01'
    }
  }
}
</script>

<template>
  <FormGroup :group-classes="groupClasses" :has-error="hasError" :id="renderedId">
    <template #label>{{ label }}</template>

    <Price
        v-bind="$attrs"
        :form="form"
        :name="name"
        :step="step"
        :id="renderedId"
        :model-value="modelValue"
        @update:modelValue="changeModelValueTo"
    />
  </FormGroup>
</template>